<template>
  <section class="section">
    <div class="container no-print" style="margin-top: -30px;">
      <div class="columns" >
        <div class="column">
          <span class="title24"> {{ selectedEventName }}</span>
        </div>
          
      </div>
      <b-tabs v-model="activeTab" >
        <b-tab-item label="ລາຍການງານ/ Event" >
          <table class="table is-fullwidth is-narrow is-small" >
            <thead>
              <tr>
                <th class="has-text-left " width="2%">
                  ລຳດັບ
                </th>
                <th class="has-text-left " width="40%">
                  ຊື່ງານ/ Event
                </th>

                <th class="has-text-left " width="20%">
                  ວັນ ແລະ ເວລາ
                </th>
                
                <th class="has-text-centered " width="20%">
                  ລາຍລະອຽດ
                </th>
                
              </tr>
            </thead>
            <tbody>
              <tr
                v-for="(data, index) in eventList"
                :key="data.ID"
              >
                <td class="has-text-left ">
                  {{ index +1 }}
                </td>
                <td class="has-text-left ">
                  {{ data.NAME }}&nbsp;<span v-if="data.ISPAY==1" class="red14bold">(ເສຍເງິນ)</span>    
                </td>
                <td class="has-text-left ">
                  {{ dateFormatter(data.STARTDATE) }}  {{ data.STARTTIME }} - {{ data.ENDTIME }}    
                </td> 
                <td class="has-text-centered ">
                  <b-field>
                    <b-button class="btn-group-margin is-fullwidth"
                        type="is-info"  
                        size="is-small"
                        @click="getEventDetail(data, 1)"
                        >  <span > ຕິດຕາມ</span>
                    </b-button>
                  </b-field>
                    
                 
              </td> 
                
              </tr>
            </tbody>
            
          </table>
        </b-tab-item>
        
        <b-tab-item label="ຕິດຕາມການເຂົ້າຮ່ວມງານ" >
          <div class="columns" v-if="participateList.length > 0">  
            <div class="column">
              <b-field grouped>
                <b-field >
                ຄົ້ນຫາ
                </b-field>
                <b-field >
                  <b-input
                    placeholder="ຊື່ ຫຼື ນາມສະກຸນ"
                    v-model.trim="searchByFullName"
                    @input="searchData(1)"  
                    type="text"
                  >  
                  </b-input>
                </b-field>
                <b-field >
                  <b-input
                    placeholder="ເບີໂທ"
                    v-model.trim="searchByPhoneno"
                    type="text"
                    @input="searchData(2)"  
                  >  
                  </b-input>
                </b-field>
                <b-field >
                  <b-input
                  
                    placeholder="ເລກລົງທະບຽນ"
                    v-model.trim="searchByRegisterID"
                    type="text"
                    @input="searchData(3)"  
                  >  
                  </b-input>
                </b-field>
               
              </b-field>
                
            </div>
          </div>

         
         
          <table class="table is-fullwidth is-narrow is-small" v-if="selectedEventtype ==1">
            <thead>
              <tr>
                <th class="has-text-left " width="2%">
                  #
                </th>
                <th class="has-text-left " width="2%">
                  Reg
                </th>
                <th class="has-text-left " width="10%">
                  ພາກສ່ວນ
                </th>
                <th class="has-text-left " width="10%">
                  ຊື່ ແລະ ນາມສະກຸນ
                </th>
                <th class="has-text-left " width="15%">
                  ກຸ່ມເຂົ້າຮ່ວມ
                </th>
                <th class="has-text-left " width="5%">
                  ເບີໂທ
                </th>
                <th class="has-text-centered " width="8%">
                  ສະຖານະ  
                </th>
                <th class="has-text-centered " width="10%">
                  ລາຍລະອຽດ 
                </th>
                
              </tr>
            </thead>
            <tbody>
              <tr
                v-for="(data, index) in filteredParticipateList "    
                :key="data.ID"
              >
                <td class="has-text-left " :style="{ backgroundColor: data.STATUS== 3 ? '#03A9F4' :  
                                                                      data.STATUS == 2  ? '#D4E157' : 
                                                                      data.STATUS== 0 ? '#CFD8DC' :'transparent', 
                                                     color: data.STATUS== 3 ? 'white' :''
                                                }">
                  <span >
                    {{index +1}}
                  </span>
                  
                </td>

                <td class="has-text-left " :style="{ backgroundColor: data.STATUS== 3 ? '#03A9F4' :  
                                                                      data.STATUS == 2  ? '#D4E157' : 
                                                                      data.STATUS== 0 ? '#CFD8DC' :'transparent', 
                                                     color: data.STATUS== 3 ? 'white' :''
                                                }">
                  <span >
                    {{data.ID}}
                  </span>
                  
                </td>
                <td class="has-text-left " :style="{ backgroundColor: data.STATUS== 3 ? '#03A9F4' : 
                                                                      data.STATUS == 2  ? '#D4E157' : 
                                                                      data.STATUS== 0 ? '#CFD8DC' :'transparent', 
                                                     color: data.STATUS== 3 ? 'white' :''
                                                }">
                  
                  {{ data.ORGANIZATION }}
                </td>
                <td class="has-text-left " :style="{ backgroundColor: data.STATUS== 3 ? '#03A9F4' : 
                                                                      data.STATUS == 2  ? '#D4E157' : 
                                                                      data.STATUS== 0 ? '#CFD8DC' :'transparent', 
                                                     color: data.STATUS== 3 ? 'white' :''
                                                }">
                  
                  {{ data.FULLNAME }}
                </td>
                <td class="has-text-left " :style="{ backgroundColor: data.STATUS== 3 ? '#03A9F4' : 
                                                                      data.STATUS == 2  ? '#D4E157' : 
                                                                      data.STATUS== 0 ? '#CFD8DC' :'transparent', 
                                                     color: data.STATUS== 3 ? 'white' :''
                                                }">
                  {{ data.SECTIONNAME }}
                </td> 
                <td class="has-text-left " :style="{ backgroundColor: data.STATUS== 3 ? '#03A9F4' : 
                                                                      data.STATUS == 2  ? '#D4E157' : 
                                                                      data.STATUS== 0 ? '#CFD8DC' :'transparent', 
                                                     color: data.STATUS== 3 ? 'white' :''
                                                }">
                  {{ data.PHONENO }}
                </td> 
                <td class="centered-content"  :style="{ backgroundColor: data.STATUS== 3 ? '#03A9F4' : 
                                                                      data.STATUS == 2  ? '#D4E157' : 
                                                                      data.STATUS== 0 ? '#CFD8DC' :'transparent', 
                                                     color: data.STATUS== 3 ? 'white' :''
                                                }">
                  <b-field grouped style="margin-left: 5px; ">
                    
                    <b-field v-if="data.STATUS == 1" style="padding-top: 5px;">   
                      ລໍຖ້າຢືນຢັນ
                    </b-field>

                    <b-field v-if="data.STATUS == 2" style="padding-top: 5px;">  
                        ຕອບເຂົ້າຮ່ວມ
                      </b-field>
                   
                      
                    <b-field v-if="data.STATUS == 3" style="padding-top: 5px;">   
                      ✅ ເຂົ້າງານແລ້ວ
                    </b-field>
                      
                    <b-field v-if="data.STATUS == 0" style="padding-top: 5px;">
                      ❌ ຕອບບໍ່ເຂົ້າຮ່ວມ
                    </b-field>
                  </b-field>
                </td>
                <td class="has-text-centered " :style="{ backgroundColor: data.STATUS== 3 ? '#03A9F4' : 
                                                                      data.STATUS == 2  ? '#D4E157' : 
                                                                      data.STATUS== 0 ? '#CFD8DC' :'transparent', 
                                                     color: data.STATUS== 3 ? 'white' :''
                                                }">
                  <b-field>
                    <b-button 
                        class="btn-group-margin is-fullwidth"
                        type="is-info"  
                        size="is-small"
                        @click="getParticipateDetail(data)"
                        >  <span > ລາຍລະອຽດ</span>
                    </b-button>
                    
                  </b-field>
                </td> 
                
              </tr>
            </tbody>
            
          </table>

          <table class="table is-fullwidth is-narrow is-small" v-if="selectedEventtype ==2">
            <thead>
              <tr>
                <th class="has-text-left " width="2%">
                  Reg
                </th>
                <th class="has-text-left " width="10%">
                  ພາກສ່ວນ
                </th>
                <th class="has-text-left " width="10%">
                  ຊື່ ແລະ ນາມສະກຸນ
                </th>
                <th class="has-text-left " width="15%">
                  ກຸ່ມເຂົ້າຮ່ວມ
                </th>
                <th class="has-text-left " width="5%">
                  ເບີໂທ
                </th>
                <th class="has-text-centered " width="20%">
                  ຈັດການ 
                </th>
                <th class="has-text-centered " width="8%">
                  ສະຖານະ  
                </th>
              </tr>
            </thead>
            <tbody>
              <tr
                v-for="(data) in filteredParticipateList "
                :key="data.ID"
              >
              <td class="has-text-left " :style="{ backgroundColor: data.STATUS== 3 ? '#03A9F4' :  
                                                                      data.STATUS == 2  ? '#D4E157' : 
                                                                      data.STATUS== 0 ? '#CFD8DC' :'transparent', 
                                                     color: data.STATUS== 3 ? 'white' :''
                                                }">
                  <span >
                    {{data.ID}}
                  </span>
                  
                </td>
                <td class="has-text-left " :style="{ backgroundColor: data.STATUS== 3 ? '#03A9F4' : 
                                                                      data.STATUS == 2  ? '#D4E157' : 
                                                                      data.STATUS== 0 ? '#CFD8DC' :'transparent', 
                                                     color: data.STATUS== 3 ? 'white' :''
                                                }">
                  
                  {{ data.ORGANIZATION }}
                </td>
                <td class="has-text-left " :style="{ backgroundColor: data.STATUS== 3 ? '#03A9F4' : 
                                                                      data.STATUS == 2  ? '#D4E157' : 
                                                                      data.STATUS== 0 ? '#CFD8DC' :'transparent', 
                                                     color: data.STATUS== 3 ? 'white' :''
                                                }">
                  
                  {{ data.FULLNAME }}
                </td>
                <td class="has-text-left " :style="{ backgroundColor: data.STATUS== 3 ? '#03A9F4' : 
                                                                      data.STATUS == 2  ? '#D4E157' : 
                                                                      data.STATUS== 0 ? '#CFD8DC' :'transparent', 
                                                     color: data.STATUS== 3 ? 'white' :''
                                                }">
                  {{ data.SECTIONNAME }}
                </td> 
                <td class="has-text-left " :style="{ backgroundColor: data.STATUS== 3 ? '#03A9F4' : 
                                                                      data.STATUS == 2  ? '#D4E157' : 
                                                                      data.STATUS== 0 ? '#CFD8DC' :'transparent', 
                                                     color: data.STATUS== 3 ? 'white' :''
                                                }">
                  {{ data.PHONENO }}
                </td> 
                <td class="has-text-centered " :style="{ backgroundColor: data.STATUS== 3 ? '#03A9F4' : 
                                                                      data.STATUS == 2  ? '#D4E157' : 
                                                                      data.STATUS== 0 ? '#CFD8DC' :'transparent', 
                                                     color: data.STATUS== 3 ? 'white' :''
                                                }">
                  <b-field>
                    <b-button 
                        class="btn-group-margin is-fullwidth"
                        type="is-info"  
                        size="is-small"
                        @click="getParticipateDetail(data)"
                        >  <span > ລາຍລະອຽດ</span>
                    </b-button>
                    <b-button 
                        class="btn-group-margin is-fullwidth"
                        type="is-primary"  
                        size="is-small"
                        @click="openEditForm(data)"
                        >  <span > ແກ້ໄຂຂໍ້ມູນ</span>
                    </b-button>
                    <b-button v-if="data.PAYSTATUS == 1 && data.STATUS == 2"   
                        class="btn-group-margin is-fullwidth"
                        type="is-danger"   
                        size="is-small"
                        @click="joinEvent(data.ID,3,1)"
                    >
                      ເຂົ້າໃນງານ
                    </b-button>
                    <b-button v-if="data.PAYSTATUS == null && data.STATUS == 1"   
                        class="btn-group-margin is-fullwidth"
                        type="is-danger"  
                        size="is-small"  
                        @click="joinEvent(data.ID,2,1)"
                        >  <span > ຢືນຢັນການຊຳລະ</span>
                    </b-button>
                    <b-button v-if="data.STATUS == 1"   
                        class="btn-group-margin is-fullwidth"
                        type="is-warning"  
                        size="is-small"
                        @click="joinEvent(data.ID,0,0)"
                    >
                      ບໍ່ເຂົ້າຮ່ວມ
                    </b-button>
                    
                  </b-field>
                </td> 
                <td class="centered-content"  :style="{ backgroundColor: data.STATUS== 3 ? '#03A9F4' : 
                                                                      data.STATUS == 2  ? '#B3E5FC' : 
                                                                      data.STATUS== 0 ? '#CFD8DC' :'transparent', 
                                                     color: data.STATUS== 3 ? 'white' :''
                                                }">
                  
                    <b-field v-if="data.PAYSTATUS == 1 && data.STATUS==2">    
                      ✅ ຊຳລະແລ້ວ
                    </b-field>
                    <b-field v-if="data.PAYSTATUS == 0">    
                      ❌ ບໍ່ຊຳລະ-ບໍ່ເຂົ້າຮ່ວມ
                    </b-field>
                    <b-field v-if="data.PAYSTATUS == 1 && data.STATUS == 3">      
                      ✅ ເຂົ້າງານແລ້ວ
                    </b-field>
                    <b-field v-if="data.PAYSTATUS == null" class="red14">       
                      ລໍຖ້າຊຳລະ  
                    </b-field>
              
                </td>
              </tr>
            </tbody>
            
          </table>
        </b-tab-item>
        
        <b-tab-item label="ລາຍລະອຽດ" >
          <div class="columns" v-if="participateFullname">
            <div class="column">
              <div class="columns" >
                <div class="column">
                  <b-field>
                    <span  class="title16-light" style="margin-right: 10px;">ຊື່ ແລະ ນາມສະກຸນ: </span><span  class="title16">{{ participateFullname }} </span>
                  </b-field>
                  <b-field>
                    <span  class="title16-light" style="margin-right: 10px;">ອາຍຸ: </span><span   style="margin-right: 5px;" class="title16">{{ participateAge }} </span>
                  </b-field>
                  <b-field>
                    <span  class="title16-light" style="margin-right: 10px;">ເພດ: </span><span  class="title16">{{ participateGender }} </span>
                  </b-field>
                  <b-field>
                    <span  class="title16-light" style="margin-right: 10px;">ພາກສ່ວນ: </span><span  class="title16">{{ participateOrganization }} </span>
                  </b-field>
                  <b-field>
                    <span  class="title16-light" style="margin-right: 10px;">ຕຳແໜ່ງ: </span><span  class="title16">{{ participatePosition }} </span>
                  </b-field>
                  <b-field>
                    <span  class="title16-light" style="margin-right: 10px;">ກຸ່ມເຂົ້າຮ່ວມ: </span><span  class="title16">{{ participateSection }} </span>
                  </b-field>
                  <b-field>
                    <span  class="title16-light" style="margin-right: 10px;">ຫົວຂໍ້ທີ່ສົນໃຈ: </span><span  class="title16">{{ participateInterested }} </span>
                  </b-field>
                  <b-field>
                    <span  class="title16-light" style="margin-right: 10px;">ເບີໂທ: </span><span  class="title16">{{ participatePhoneNo }} </span>
                  </b-field>
                  

                  <b-field v-if="participateStatus == 2 && selectedEventtype==1" class="red16bold"> 
                    ຢືນຢັນແລ້ວ
                  </b-field>
                  <b-field v-if="participateStatus == 2 && selectedEventtype==1"> 
                    ✅ ຢືນຢັນເມື່ອ: {{ this.txdateconfirm }}
                  </b-field>
                  

                  
                  <b-field v-if="participateStatus == 3 && selectedEventtype==1" class="red16bold"> 
                    ✅ເຂົ້າງານແລ້ວ
                  </b-field>
                  <b-field v-if="participateStatus == 3 && selectedEventtype==1"> 
                    ເຂົ້າງານເມື່ອ: {{ this.txdateenter }}
                  </b-field>

                  <b-field v-if="participateStatus == 1 && selectedEventtype==2" >
                    <b-button  
                          class="btn-group-margin is-fullwidth"
                          type="is-danger"  
                          >  <span > ກົດເພື່ອຢືນຢັນການຊຳລະ</span>
                    </b-button>
                  </b-field>

                  <b-field v-if="(participateStatus == 3 || participateStatus == 2) && selectedEventtype==2" class="red16bold"> 
                  ✅ ຊຳລະແລ້ວ
                  </b-field>
                  <b-field v-if="participateStatus == 3 && selectedEventtype==2" class="red16bold"> 
                    ✅ ເຂົ້າງານແລ້ວ 
                  </b-field>
                  <b-field v-if="participateStatus == 3 && selectedEventtype==2"> 
                    ເຂົ້າງານເມື່ອ: {{ this.txdateenter }}
                  </b-field>

                  
                  <br>
                  <b-field v-if="participateFullname && (participateStatus ==1 || participateStatus ==2)">
                    <div>
                      ແຈ້ງ QR ໜ້າງານເພື່ອເຂົ້າງານ
                    </div>
                      
                  </b-field>
                  <b-field v-if="participateFullname && (participateStatus ==1 || participateStatus ==2)">
                   
                    <div>
                      <img :src="qrCodeUrl" alt="QR Code" />
                    </div>
                      
                  </b-field>
                  <b-field v-if="participateFullname && (participateStatus ==1 || participateStatus ==2)">
                   
                    <b-button class="btn-group-margin"
                        type="is-info"  
                        @click="print()"
                        >  <span > ພິມ QR</span>
                    </b-button>
                     
                 </b-field>
                 
                </div>
              
              </div>

              <div class="columns" v-if="participateFullname">  
                <div class="column" >
                  <b-field style=" display: block; margin-bottom: 0px; width: 330px; padding: 5px 10px 10px 10px;  
                                  border-radius: 10px; display: block; border: 2px solid #039BE5;" >
                    <b-field style="text-align: center; display: flex; justify-content: center; align-items: center; ">
                      <b-field style=" width: 175px; text-align: right">
                        <img :src="forestlogo"  width="75%"/>
                      </b-field>

                      <b-field style="  width: 175px; text-align: left; padding-left: 10px; margin-top: -10px;">  
                        <img :src="labalogo" width="68%"/>
                      </b-field>
                      
                      
                    </b-field>
                    <b-field style="text-align: center; display: flex; justify-content: center; align-items: center; margin-top: -25px; margin-bottom: -5px;">
                        <b-field style="background-color: #039BE5; width: 370px; text-align: center; color: white; font-size: 20px;
                                    padding: 5px; border-radius: 5px; box-shadow: 0 4px 8px rgba(0, 0, 0, 0.1); display: block; margin-bottom: 10px;"> 
                            ບັດເຂົ້າຮ່ວມງານ Agri-Expo 2024
                        </b-field>
                    </b-field>
                    
                    <b-field style="padding: 10px 0px 0px 0px; "> 
                      <b-field style="width: 85px; background-color: #039BE5; color: white; height: 130px;
                                      padding: 5px 5px 5px 5px; border-radius: 5px; box-shadow: 0 4px 8px rgba(0, 0, 0, 0.1); display: block;">
                        ຊື່ ແລະ <br>ນາມສະກຸນ 
                      </b-field>
                      <b-field style="width: 265px; color: black; height: 130px; margin-left: 5px;
                                      padding: 5px 5px 5px 5px; border-radius: 5px; display: block; border: 2px solid #039BE5;">
                        {{participateFullname}}
                      </b-field>  
                        
                    </b-field>
                    <b-field style="padding: 10px 0px 0px 0px; margin-top: -20px;  " v-if="participatePosition">
                      <b-field style="width: 85px; background-color: #039BE5; color: white; height: 60px;
                                      padding: 5px 5px 5px 5px; border-radius: 5px; box-shadow: 0 4px 8px rgba(0, 0, 0, 0.1); display: block;">
                        ຕຳແໜ່ງ 
                      </b-field>
                      <b-field style="width: 265px; color: black; height: 60px; margin-left: 5px; 
                                      padding: 5px 5px 5px 5px; border-radius: 5px; display: block; border: 2px solid #039BE5;
                                      ">
                        {{ participatePosition}}
                      </b-field>
                        
                    </b-field>
                    <b-field style="padding: 10px 0px 0px 0px; margin-top: -20px; " v-if="participateOrganization">
                      <b-field style="width: 85px; background-color: #039BE5; color: white; height: 60px;
                                      padding: 5px 5px 5px 5px; border-radius: 5px; box-shadow: 0 4px 8px rgba(0, 0, 0, 0.1); display: block;">
                        ພາກສ່ວນ 
                      </b-field>
                      <b-field style="width: 265px; color: black; height: 60px; margin-left: 5px; 
                                      padding: 5px 5px 5px 5px; border-radius: 5px; display: block; border: 2px solid #039BE5;
                                      ">
                        {{ participateOrganization}} 
                      </b-field>
                        
                    </b-field>
                    <b-field style="padding: 10px 0px 0px 0px; margin-top: -20px; ">
                      <b-field style="width: 85px; background-color: #039BE5; color: white; height: 35px;
                                      padding: 5px 5px 5px 5px; border-radius: 5px; box-shadow: 0 4px 8px rgba(0, 0, 0, 0.1); display: block;">
                        ເບີໂທ 
                      </b-field>
                      <b-field style="width: 265px; color: black; height: 35px; margin-left: 5px; 
                                      padding: 5px 5px 5px 5px; border-radius: 5px; display: block; border: 2px solid #039BE5;
                                      ">
                        {{ participatePhoneNo }}
                      </b-field>
                        
                    </b-field>
                    <b-field style="text-align: center; display: block; margin-bottom: -5px; margin-top: -10px;"> 
                        <img :src="qrCodeUrl" alt="QR Code" />   
                    </b-field>
                </b-field>

                    
                  
                </div>
              </div>

              
              
            </div>
              
            <div class="column">
              
            </div>
            
              
          </div>
        </b-tab-item>
        
      </b-tabs>
      

      
    </div>

    <div class="contain print-only">
  <div class="columns" style="width: 100%; height: 100%; overflow: hidden;">
    <div class="column" style="width: 100%;">
      <b-field>
        <span class="title16-light" style="margin-right: 10px;">ຊື່ ແລະ ນາມສະກຸນ: </span>
        <span class="title16">{{ participateFullname }}</span>
      </b-field>
      <b-field>
        <img :src="qrCodeUrl" alt="QR Code" style="max-width: 100%; height: auto;" />
      </b-field>
    </div>
  </div>
</div>


    
    
    

    
    
    
  </section>
</template>

<script>
import RestAPI from "../../RestAPI";
// import Multiselect from "vue-multiselect";
import moment from "moment";
// import axios from "axios";


// import { BFormSelect } from 'bootstrap-vue'



export default {
  // components: { Multiselect, BFormSelect},
  // components: { Multiselect },

  props: {
    regno: {
      type: String,
      required: false, // Make it optional to support both routes
    },
  },
  data() {
    return {
      roleid: null,
      userName: null,

      activeTab: 0,

      selectedSection: null,
      selectionList: [],

      participateList: [],

      eventList: [],

      selectedInterested: null,
      interestedList: [],

      selectedEventID: null,
      selectedEventName: null, 
      
      selectedOrganization: null,
      selectedPosition: null,
      selectedFullName: null,
      ageRangList: [],
      selectedAge: null,
      genderList:[] ,
      selectedGender: null,
      selectedPhoneNo: null,

      participateOrganization: null, 
      participatePosition: null,
      participateFullname: null,
      participateAge: null,
      participateGender: null,
      participateSection: null,
      participateInterested: null,
      participatePhoneNo: null,
      participateStatus: null,  
      txdateconfirm: null,
      txdateenter: null,

      qrData: null,

      

      eventTitle: null,

      searchByFullName: null,
      searchByPhoneno: null,
      searchByRegisterID: null,
      
      filteredParticipateList: [],

      selectedEventtype: 0,
      
      regsiterByPhoneno: null,
      phoneNoEventList: [],

      isSearch: 0,
      isEditForm: 0,

      selectedEventData: [],
      selectedRegister: null,

      selectedRegno: null,
    };
     
    
  },
  methods: {   

    print() {
 
          window.print();
           
        
        
    },

    getSection() {
      RestAPI.getSection()
        .then((res) => {
          this.selectionList = res.data.responseData.data;
        })
        .catch((error) => {
          console.log(error);
          this.$swal("ມີຂໍ້ຜິດພາດ", "-", "error");
        });
    },

    getGender() {
      RestAPI.getGender()
        .then((res) => {
          // console.log("con: "+ JSON.stringify(res.data))
          this.genderList = res.data.responseData.data;
        })
        .catch((error) => {
          console.log(error);
          this.$swal("ມີຂໍ້ຜິດພາດ", "-", "error");
        });
    },

    getAgeRang() {
      RestAPI.getAgeRang()
        .then((res) => {
          // console.log("con: "+ JSON.stringify(res.data))
          this.ageRangList = res.data.responseData.data;
        })
        .catch((error) => {
          console.log(error);
          this.$swal("ມີຂໍ້ຜິດພາດ", "-", "error");
        });
    },

    getInterested() {
      RestAPI.getInterested()
        .then((res) => {
          // console.log("con: "+ JSON.stringify(res.data))
          this.interestedList = res.data.responseData.data;
        })
        .catch((error) => {
          console.log(error);
          this.$swal("ມີຂໍ້ຜິດພາດ", "-", "error");
        });
    },

    openEditForm(data){
      // console.log("Data: " + JSON.stringify(data))
      this.activeTab =2;
      this.isEditForm = 1;
      this.selectedRegister = data.REGISTERID;
      this.selectedOrganization = data.ORGANIZATION;
      this.selectedPosition = data.POSITION;
      this.selectedFullName = data.FULLNAME;
      this.selectedAge = {"ID": data.AGEID,"NAME": data.AGETITLE};
      this.selectedGender = {"ID": data.GENDERID,"NAME": data.GENDERTITLE};
      this.selectedSection = {"ID": data.SECTIONID,"NAME": data.SECTIONNAME};
      this.selectedInterested = {"ID": data.INTERESTEDID,"NAME": data.INTERESTEDTITLE};
      this.selectedPhoneNo = data.PHONENO;
    },
    
    searchRegsiterByPhoneno(){
      this.isSearch = 1;
      var params = {
        phoneno: this.regsiterByPhoneno,
        eventid: this.selectedEventID,
        username: this.username,  
      };
      RestAPI.searchRegsiterByPhoneno(params)
        .then((res) => {
          this.selectedOrganization = null;
          this.selectedPosition = null;
          this.selectedFullName = null;
          this.selectedAge = null;
          this.selectedGender = null;
          this.selectedSection = null;
          this.selectedPhoneNo = null;
          this.selectedInterested = null;
          this.phoneNoEventList = res.data.responseData.data.list;
        })
        .catch((error) => {
          console.log(error);
          this.$swal("ມີຂໍ້ຜິດພາດ", "-", "error");
        });
    },  
    

    

    eventCome(type){
      console.log("type: " + type)
      this.$swal({
        title: "ສຳເລັດ",
        text: "ດຳເນີນການ ສຳເລັດ!",
        icon: "success",
        showConfirmButton: true, 
      });
    },

   

    paymentConfirm(){
      this.$swal({
        title: "ສຳເລັດ",
        text: "ດຳເນີນການ ສຳເລັດ!",
        icon: "success",
        showConfirmButton: true, 
      });
    },

    openParticipateForm(){
      this.activeTab = 2;
      this.isEditForm = 0;
      this.selectedOrganization = null;
      this.selectedPosition = null;
      this.selectedFullName = null;
      this.selectedAge = null;
      this.selectedGender = null;
      this.selectedSection = null;
      this.selectedInterested = null;
      this.selectedPhoneNo = null;
    },

    searchData(type){
      if(type ==1){
        this.searchByPhoneno = null;
        this.searchByRegisterID = null;
        this.filteredParticipateList = this.participateList.filter(data => {
          return data.FULLNAME.toLowerCase().includes(this.searchByFullName.toLowerCase());
        });
      }
      else if(type ==2){
        this.searchByFullName = null;
        this.searchByRegisterID = null;
        this.filteredParticipateList = this.participateList.filter(data => {
          return data.PHONENO.toLowerCase().includes(this.searchByPhoneno.toLowerCase());
        });
      }else if(type ==3){
        this.searchByFullName = null;
        this.searchByPhoneno = null;
        this.filteredParticipateList = this.participateList.filter(data => {
          return data.ID.toString().toLowerCase().includes(this.searchByRegisterID.toLowerCase());
        });
      }

      

      
    },

    // registerForm(data){  
    //   this.regsiterByPhoneno = null;
    //   this.phoneNoEventList = [];
    //   this.activeTab = 2;
    //   this.selectedEventName = data.NAME;
    //   this.selectedEventID = data.ID;
    //   this.isSearch = 0;
    //   this.isEditForm = 0;
      
    // },
    
    
    getEventDetail(data, type){ 
      if(type ==1){
        this.activeTab = 1;
      }else{
        this.activeTab = 2;
      }

      this.selectedEventData = data; 
      this.regsiterByPhoneno = null;
      this.phoneNoEventList = [];
      this.selectedEventName = data.NAME;
      this.selectedEventID = data.ID;
      this.isSearch = 0;
      this.isEditForm = 0;


      RestAPI.getEventDetail(data.ID)
        .then((res) => {
          // console.log("res: "+JSON.stringify(res))
          if( res.data.responseData.data.length > 0){
            this.participateList = res.data.responseData.data;
            this.filteredParticipateList = res.data.responseData.data;
            this.selectedEventtype = res.data.responseData.data ? res.data.responseData.data[0].EVENTTYPE : '';  
          }
          
          
          // console.log("res.data.filteredParticipateList.data: "+ JSON.stringify(res.data.responseData.data))    
        })
        .catch((error) => {
          console.log(error);
          this.$swal("ມີຂໍ້ຜິດພາດ", "-", "error");
        });
      
    },
    
    getParticipateDetail(data){
      this.selectedRegno = data.ID;
      this.activeTab = 2; 
      this.participateOrganization = data.ORGANIZATION;
      this.participatePosition = data.POSITION;
      this.participateFullname = data.FULLNAME;
      this.participateAge = data.AGETITLE;
      this.participateGender = data.GENDERTITLE;
      this.participateSection = data.SECTIONNAME;
      this.participateInterested = data.INTERESTEDTITLE;  
      this.participatePhoneNo = data.PHONENO;
      this.participateStatus=  data.STATUS;
      this.txdateconfirm =  data.TXDATECONFIRM;
      this.txdateenter=  data.TXDATEENTER;

      this.qrData = "https://lababiz.com/#/event/checkParticipate/"+ this.selectedRegno;
    },
   
    getEvent() {
      RestAPI.getEvent()
        .then((res) => {
          // console.log("con: "+ JSON.stringify(res.data))
          this.eventList = res.data.responseData.data.normal;
        })
        .catch((error) => {
          console.log(error);
          this.$swal("ມີຂໍ້ຜິດພາດ", "-", "error");
        });
    },

    dateFormatter(date) {
      return new moment(date).format("DD/MM/YYYY");
    },
    dateTimeFormatter(date) {      
      // return date ? moment(date).format("YYYY-MM-DD HH:mm:ss") : "";  
      return new moment(date).format("YYYY-MM-DD HH:mm:ss");
    },
    dateFormatterYYYYMMDD(date) {
      return new moment(date).format("YYYY-MM-DD");
    },
 
    

    

  },
  mounted() {
    this.roleid = this.user ? this.user.ROLEID : null;
    this.roleid = 3;
    this.username = this.user.USERNAME;   

    this.currentDate = new Date();


    this.getEvent();
    this.getSection();
    this.getGender();
    this.getAgeRang();
    this.getInterested();
    
    

  
  },

  computed: {
    formdatestr() {
      return new moment(this.formdate).format("YYYY-MM-DD");
    },

    qrCodeUrl() {
      // Use the qrserver API to generate the QR code image URL
      return `https://api.qrserver.com/v1/create-qr-code/?size=200x200&data=${encodeURIComponent(this.qrData)}`;
    },
    labalogo() {
      return process.env.NODE_ENV === 'production'
        ? 'https://lababiz.com/api/uploads/logo/labalogo.png'
        : 'http://localhost/lababiz/api/uploads/logo/labalogo.png';
    },

    forestlogo() {
      return process.env.NODE_ENV === 'production'
        ? 'https://lababiz.com/api/uploads/logo/forestlogo.png'
        : 'http://localhost/lababiz/api/uploads/logo/forestlogo.png';
    },
  
   
  },
};
</script>
<style src="vue-multiselect/dist/vue-multiselect.min.css"></style>
<style scoped>

@media print {
  @page {
    margin: 0; /* Remove all margins */
    size: 6in 9in; /* Ensure the page size matches your content */
  }

  body {
    margin: 0;
    padding: 0;
    width: 6in;
    height: 9in;
    overflow: hidden;
    box-sizing: border-box; /* Prevent unexpected dimensions */
  }

  .contain {
    margin: 0;
    padding: 0;
    width: 100%;
    height: 100%;
    display: flex; /* Align items properly */
    flex-direction: column;
    align-items: center;
    justify-content: center;
  }

  img {
    max-width: 100%; /* Prevent the image from exceeding its container */
    max-height: 100%; /* Fit within the allocated space */
  }

  .print-only {
    display: block;
  }

  .no-print {
    display: none;
  }
}

.status-3 {
  background-color: #4FC3F7; /* Light blue for status 3 */
  color: white;
}

.status-2 {
  background-color: #B3E5FC; /* Lighter blue for status 2 */
  color: black;
}

.status-0 {
  background-color: #CFD8DC; /* Gray for status 0 */
  color: black;
}

.status-default {
  background-color: transparent; /* Default styling */
  color: inherit;
}

.centered-content {
  flex-direction: column;
  align-items: center;
  justify-content: center;
  text-align: center;
}

.card {
  border: 1px solid #ddd;
  border-radius: 5px;
  padding: 10px;  
  margin-bottom: 0px;
  box-shadow: 0 4px 8px rgba(0, 0, 0, 0.1);
}

.content{
  font-size: 16px;
  margin-left: 5px; 
  margin-right: 5px;
}

.title24{
  font-size: 24px;
  font-weight: bold;
}

.title24-light{
  font-size: 24px;
}

.title20{
  font-size: 20px;
  font-weight: bold;
}

.title20-light{
  font-size: 20px;
}

.title16{
  font-size: 18px;
  font-weight: bold;
}

.title16-light{
  font-size: 18px;
}

.title14{
  font-size: 16px;
  font-weight: bold;
}
.title14-light{
  font-size: 16px;
  font-weight: bold;
}

.title12{
  font-size: 14px;
  font-weight: bold;
}

.title12-light{
  font-size: 14px;
}

.red16bold{
  color: red;
  font-size: 18px;
  font-weight: bold;
}

.red16{
  color: red;
  font-size: 18px;
  
}

.red14bold{
  color: red;
  font-size: 16px;
  font-weight: bold;
}

.red14{
  color: red;
  font-size: 16px;
}

.red12bold{
  color: red;
  font-size: 14px;
  font-weight: bold;
}

.red12{
  color: red;
  font-size: 14px;
}




.container{  
  margin-top: 10px;
}
.popup {
  display: block;
  position: fixed;
  z-index: 1;
  padding-top: 60px;
  left: 0;
  top: 0;
  width: 100%;
  height: 100%;
  overflow: auto;
  background-color: rgba(0, 0, 0, 0.9);
}
/* Style for the popup content (image) */
.popup-content {
  margin: auto;
  display: block;
  width: 80%;
  max-width: 700px;
}

/* Add animation (optional) */
.popup-content {
  -webkit-animation-name: zoom;
  -webkit-animation-duration: 0.6s;
  animation-name: zoom;
  animation-duration: 0.6s;
}
.receipt-highigt{
  font-weight: bold;
}
.custom-flex-wrap {
  display: flex;
  flex-wrap: wrap;
  gap: 5px; /* Optional: adds some spacing between the items */
}

.product-name {
  width: 100%; /* Forces the field to take full width on small screens */
  margin-top: 5px; /* Optional: adds some top margin */
}

.column-50 {
  flex: 0 0 50%;
}

.column-65 {
  flex: 0 0 65%;
}

.column-35 {
  flex: 0 0 35%;
}

.column-30 {
  flex: 0 0 30%;
}
.column-70 {
  flex: 0 0 70%;
}

.column-20 {
  flex: 0 0 20%;
}
.column-80 {
  flex: 0 0 80%;
}


.asterisk {
  color: red;
}
  
.set-border {
  border: 1px solid #838282;      
}

tbody tr:last-child td {
  border-bottom: 1px solid #000; /* Specifically target the last row's bottom border */
}

.summary-footer {
  page-break-before: always;
}

.modal {  
  display: none;
  position: fixed;
  z-index: 1;
  left: 0;
  top: 0;
  width: 100%;
  height: 100%;
  overflow: auto;
  background-color: rgba(0, 0, 0, 0.4);
}

/* Style for the modal content */
.modal-content {
  background-color: #fefefe;
  margin: 15% auto;
  padding: 20px;
  border: 1px solid #888;
  width: 80%;
}

/* Style for the close button */
.close {
  color: #aaa;
  float: right;
  font-size: 28px;
  font-weight: bold;
}

.close:hover,
.close:focus {
  color: black;
  text-decoration: none;
  cursor: pointer;
}

</style>
